import { render, staticRenderFns } from "./StorageMoneyBillView.vue?vue&type=template&id=0ce08f43"
import script from "./StorageMoneyBillView.vue?vue&type=script&lang=js"
export * from "./StorageMoneyBillView.vue?vue&type=script&lang=js"
import style0 from "./StorageMoneyBillView.vue?vue&type=style&index=0&id=0ce08f43&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports